import { PATH_NUMBER_TYPE } from "@visactor/vrender-core";

import { BaseLinePicker } from "../common/base-line-picker";

export class DefaultCanvasPathPicker extends BaseLinePicker {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer, this.type = "path", this.numberType = PATH_NUMBER_TYPE;
    }
}
//# sourceMappingURL=path-picker.js.map
